<app-page-header avatarHeader="true" [svg]="'v2:fi-br-question'">
    {{ pageTitle }}
    <a mat-icon-button disableRipple
       [attr.aria-label]="routerBackButton.ariaLabel"
       [routerLink]="routerBackButton.route"
       [queryParams]="routerBackButton.queryParams">
        <mat-icon>arrow_back</mat-icon>
    </a>
</app-page-header>

<app-widget-group [data]="visibleStatuses" (widgetSelected)="updateSelectedStatus($event)"></app-widget-group>
<app-table class="request-form-submissions-table"
           [columnMap]="columnMap"
           [columnSort]="columnSort"
           [type]="tableType"
           [rowSelectable]="true"
           (showFilters)="openFilters($event)"
           (rowSelect)="goToRequestFormSubmission($event)"
           matSort
           matSortActive="title"
           matSortDirection="asc"
           matSortDisableClear="true">
    <ng-container matColumnDef="mobile">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[0].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.title">
            <app-avatar-block [svgIcon]="'v2:fi-br-question'">
                <a [routerLink]="[row.id, 'details']" [queryParams]="queryParams" avatarTitle>{{ row.title }}</a>
                <span avatarDescription>{{ row.form.organization.name }}</span>
                {{ row.createdAt | legfiDate: 'MM/DD/YYYY' }}
                <app-status-chip [statusId]="row.formSubmissionStatusId"
                                 [label]="'Form submission status'"
                                 [statuses]="statuses.data"
                                 (statusSelected)="openStatusChange(row)"
                                 preventClick>
                </app-status-chip>
            </app-avatar-block>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[1].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.title">
            <app-avatar-block [svgIcon]="'v2:fi-br-question'">
                <a [routerLink]="[row.id, 'details']" [queryParams]="queryParams" avatarTitle>{{ row.title }}</a>
                <span avatarDescription>{{ row.form.organization.name }}</span>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef><span class="no-wrap">{{ columnMap[2].title }}</span></mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!statuses || statuses.data.length === 0" preventClick>
            <app-status-chip [statusId]="row.formSubmissionStatusId"
                             [label]="'Form submission status'"
                             [statuses]="statuses.data"
                             (statusSelected)="openStatusChange(row)">
            </app-status-chip>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="unit">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[3].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.unit">
            {{ row.unit.title }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="owner">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[4].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.unit || !row.unit.owners">
            <span class="stacked">
                <ng-container *ngFor="let owner of row.unit.owners; let isLast = last">
                    <span>{{ owner.name }}<ng-container *ngIf="row.unit.owners.length > 1 && !isLast">, </ng-container></span>
                </ng-container>
            </span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="submissionDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span class="no-wrap">{{ columnMap[5].title }}</span></mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.createdAt">
            {{ row.createdAt | legfiDate: 'MM/DD/YYYY' }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="approvalsGiven">
        <mat-header-cell *matHeaderCellDef><span class="no-wrap">{{ columnMap[6].title }}</span></mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="row.ifShowApprovalsBasedOnDate && row.form.approversCount === 0" emptyCellText="{{ 'Approval Not Required' }}">
            <ng-template #priorToApprovals>
                <span class="approval-warning" [emptyCell]="true">
                    <mat-icon [matTooltip]="approvalsTooltip" [svgIcon]="'v2:fi-br-triangle-warning'"></mat-icon>
                </span>
            </ng-template>

            <ng-container *ngIf="row.ifShowApprovalsBasedOnDate; else priorToApprovals">
                <button *ngIf="row.form.approversCount > 0" mat-flat-button linkButton disableRipple preventClick (click)="showApprovalsDialog(row)">
                    {{ row.approvalsGiven + ' of ' + row.form.approversCount + ' Approved' }}
                </button>
            </ng-container>
        </mat-cell>
    </ng-container>

    <app-empty-state [icon]="'requests'">
        <span emptyStateTitle>{{ 'No form submissions so far...' }}</span>
    </app-empty-state>
</app-table>
